import { Box } from '@mui/material';
import { LogOnMount } from '@mightyhive/analytics';
import { AppGradientSurface, EntranceReveal, WelcomeHeader } from '@mightyhive/commoncomponents';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../context/UserContext';
import { RouteLocations } from './RouteLocations';
import { HubActionCard } from './home/components/HubActionCard';
import { HubActionCardWide } from './home/components/HubActionCardWide';
import { HOME_ENTRANCE_DELAYS, HOME_LAYOUT_SIZES } from './home/homeTokens';

const HOME_HEADING = 'What do you want to work on today?';
const HOME_SUBTITLE =
  'Choose a path to get started. Each workflow will guide you step by step from setup to deliverable.';

export function Home(): JSX.Element {
  const navigate = useNavigate();
  const { name, email } = useUser();
  const displayName = name || email || '';

  return (
    <AppGradientSurface>
      <LogOnMount eventName="Page View: Home" />

      <WelcomeHeader
        animateEntrance
        displayName={displayName}
        heading={HOME_HEADING}
        subtitle={HOME_SUBTITLE}
        entranceDelays={{
          greeting: HOME_ENTRANCE_DELAYS.greeting,
          heading: HOME_ENTRANCE_DELAYS.heading,
          subtitle: HOME_ENTRANCE_DELAYS.subtitle,
        }}
      />

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: `${HOME_LAYOUT_SIZES.cardGridGap}px`,
          width: '100%',
          maxWidth: HOME_LAYOUT_SIZES.hubMaxWidth,
          mx: 'auto',
        }}
      >
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
            gap: `${HOME_LAYOUT_SIZES.cardGridGap}px`,
          }}
        >
          <EntranceReveal delayMs={HOME_ENTRANCE_DELAYS.cardCreate}>
            <HubActionCard
              step="1"
              title="Create experiment"
              description="Design a new experiment from scratch. Select your platform, choose an experiment type, and produce a complete experiment plan ready for media activation."
              ctaLabel="Start new"
              onClick={() => navigate(`${RouteLocations.GRID}/create-experiment`)}
            />
          </EntranceReveal>

          <EntranceReveal delayMs={HOME_ENTRANCE_DELAYS.cardAnalyze}>
            <HubActionCard
              step="2"
              title="Analyze experiment"
              description="Run a full statistical analysis on experiment data. Connect or upload data, run diagnostics, compute results, segment findings, and generate reports."
              ctaLabel="Analyze and report"
              onClick={() => navigate(RouteLocations.ANALYSIS)}
            />
          </EntranceReveal>
        </Box>

        <EntranceReveal delayMs={HOME_ENTRANCE_DELAYS.cardLibrary}>
          <HubActionCardWide
            step="3"
            title="Go to Library"
            description="Browse all your experiments across platforms, types, and stages in one place."
            ctaLabel="Go to Library"
            onClick={() => navigate(RouteLocations.LIBRARY)}
          />
        </EntranceReveal>
      </Box>
    </AppGradientSurface>
  );
}
